
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');
const CancelCourierConsignments = (props) => {
    const handleRouteClick = (e) => {
        e.stopPropagation();
         props.onClickActive(props);
    };
    return (
        <div>
        <button onClick={handleRouteClick} className="btn btn-danger custom-btn f12 label label-success" 
        title="Add Dealer" >Cancel</button>
        
    </div>
);
    
};
export default CancelCourierConsignments;
